import { render, staticRenderFns } from "./PopupRedemtion.vue?vue&type=template&id=51ee895a"
import script from "./PopupRedemtion.vue?vue&type=script&lang=js"
export * from "./PopupRedemtion.vue?vue&type=script&lang=js"
import style0 from "./PopupRedemtion.vue?vue&type=style&index=0&id=51ee895a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports